import React from 'react';
import { SystemAdminPage } from '../SystemAdminPage';

export const TicketsPage: React.FC = () => {
  return <SystemAdminPage initialTab="tickets" />;
};
